module.exports = __webpack_public_path__ + "img/cpu.771256a9.svg";